import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-team-modal',
  templateUrl: './create-team-modal.component.html',
  styleUrls: ['./create-team-modal.component.scss']
})
export class CreateTeamModalComponent {

  constructor(private dialogRef: MatDialogRef<any>) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }
}
